import React, { Component } from 'react';
/** Personal */
import { getDom } from '../NormalStem';

class Formula extends Component {
    render() {
        const { list } = this.props;
        const divide_pair = list[0].divide_pair;
        const quotient = list[0].quotient;

        return (
            <span style={{ display: 'inline-block', textAlign: 'right' }}>
                {/* 除法左部分 */}
                {
                    divide_pair &&
                    <span style={{ display: 'inline-block', textAlign: 'right', verticalAlign: 'top' }}>
                        {
                            quotient && !!quotient.length &&
                            <span style={{ display: 'inline-block', marginBottom: 6 }}>
                                {
                                    quotient.map((q, qi) =>
                                        <span
                                            className='member-blank'
                                            style={{ border: 0, background: 'transparent' }}
                                            key={qi} />
                                    )
                                }
                            </span>
                        }
                        <span style={{ display: 'block', position: 'relative' }}>
                            {
                                divide_pair[1].map((d, di) =>
                                    <span key={di}>
                                        <span className="member">{d}</span>
                                        {
                                            di === divide_pair[1].length - 1 &&
                                            <svg width="12" height="42">
                                                <path d="M 12 0 q 0 28 -12 42" stroke="#333" strokeWidth="1" fill="none" />
                                            </svg>
                                        }
                                    </span>
                                )
                            }
                        </span>
                    </span>
                }
                {/* 除法右部分 */}
                {
                    divide_pair &&
                    <span style={{ display: 'inline-block', textAlign: 'right', verticalAlign: 'top' }}>
                        {
                            quotient && !!quotient.length &&
                            <span style={{ display: 'block', marginBottom: 6 }}>
                                {
                                    quotient.map((q, qi) =>
                                        q.indexOf('blank') > -1 ?
                                            <span
                                                className='member-blank'
                                                data-id={q.replace(/blank/g, '')}
                                                key={qi} /> :
                                            <span
                                                className='member-blank'
                                                style={{ border: 0, background: 'transparent' }}
                                                key={qi} />
                                    )
                                }
                            </span>
                        }
                        <span style={{ display: 'block', position: 'relative', borderTop: '1px solid #333' }}>
                            {
                                divide_pair[0].map((d, di) =>
                                    <span className="member" key={di}>{d}</span>
                                )
                            }
                        </span>
                    </span>
                }
                {/* 公共部分 */}
                {
                    list[0].content.map((c, ci) =>
                        <span style={{ display: 'block', position: 'relative' }} key={ci}>
                            {/* 分割线 */}
                            {
                                ci !== 0 &&
                                <span
                                    style={{
                                        margin: '6px 0',
                                        height: 1, width: '100%',
                                        background: '#333333',
                                        display: 'block'
                                    }} />
                            }
                            {/* 借位 */}
                            {
                                c.borrow_flag && !!c.borrow_flag.length &&
                                <span style={{ display: 'block' }}>
                                    {
                                        c.borrow_flag.map((f, fi) =>
                                            <span
                                                className="member"
                                                key={fi}
                                                style={{ height: 'auto', lineHeight: 0 }}>
                                                {
                                                    f.indexOf('blank') > -1 ?
                                                        <span
                                                            className='member-blank-carry'
                                                            data-id={f.replace(/blank/g, '')}
                                                            key={fi}
                                                            style={{ margin: 'auto' }} /> :
                                                        <span
                                                            className='member-blank-carry'
                                                            key={fi}
                                                            style={{ border: 0, background: 'transparent', margin: 'auto' }} />
                                                }
                                            </span>
                                        )
                                    }
                                </span>
                            }
                            {/* 主体 */}
                            {
                                c.members.map((m, mi) =>
                                    <span style={{ display: 'block', margin: '6px 0' }} key={mi}>
                                        {
                                            m.value.map((v, vi) =>
                                                v && v.toString().indexOf('blank') > -1 ?
                                                    <span
                                                        className='member-blank'
                                                        data-id={v.replace(/blank/g, '')}
                                                        key={vi} /> :
                                                    <span
                                                        className='member'
                                                        key={vi}>{v}</span>
                                            )
                                        }
                                    </span>
                                )
                            }
                            {/* 进位 */}
                            {
                                c.carry_flag && !!c.carry_flag.length &&
                                <span style={{ display: 'block', position: 'absolute', right: 0, bottom: 0 }}>
                                    {
                                        c.carry_flag.map((f, fi) =>
                                            f.indexOf('blank') > -1 ?
                                                <span
                                                    className='member-blank-carry'
                                                    data-id={f.replace(/blank/g, '')}
                                                    key={fi} /> :
                                                <span
                                                    className='member-blank-carry'
                                                    key={fi}
                                                    style={{ border: 0, background: 'transparent' }} />
                                        )
                                    }
                                </span>
                            }
                        </span>
                    )
                }
            </span>
        )
    }
}

class Stem extends Component {
    render() {
        const { stem } = this.props;

        return (
            <div>
                {
                    stem.map((para, i) =>
                        <p className={para.style} key={i}>
                            {
                                para.style === 'math_shushi' ?
                                    <Formula list={para.children} /> :
                                    para.children.map((child, j) => getDom(child, j))
                            }
                        </p>
                    )
                }
            </div>
        )
    }
}

export default Stem;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/vertical/Stem.js